<div style="color: #475569;" *ngIf="dataGridSettings.dataGridName">
  <div class="flex lg:flex-row flex-col gap-5 justify-between align-middle items-center">
    <h1 class="uppercase text-[#475569] font-bold text-3xl lg:text-4xl self-start">{{dataGridSettings.dataGridName |
      translate}}</h1>

    <div class="w-full lg:w-auto" [ngClass]="{'flex flex-row gap-5':dataGridSettings.hasGlobalSearchBar}">
      <div *ngIf="dataGridSettings.hasGlobalSearchBar" class="w-full relative">

        <input type="text" class="global-search-field px-[1rem]" minlength="1" placeholder='{{"Search" | translate}}'
          [(ngModel)]="searchModel.SearchParam">

        <div class="absolute top-[1rem] right-[2rem] hover:cursor-pointer"
          [ngClass]="{'right-[4rem]': searchDataActive}" (click)="searchData()">
          <i class="fa-sharp fa-regular fa-magnifying-glass"></i>
        </div>

        <div class="absolute top-[1rem] right-[2rem] hover:cursor-pointer" (click)="cancelSearchData();"
          *ngIf="searchDataActive" matTooltip="Избриши">
          <i class="fa-solid fa-xmark text-red-600"></i>
        </div>

      </div>

      <button mat-raised-button color="primary" class="text_color_white w-full" matTooltip="Креирај нов"
        (click)="addComponent()" *ngIf="dataGridSettings.addUrl">
        <i class="fa-regular fa-circle-plus" style="font-size: 2vh; padding-right: 1vh;"></i>{{('add' | translate) + ' '
        +
        (dataGridSettings.addButtonName! | translate)}}
      </button>

    </div>
  </div>

</div>

<mat-radio-group *ngIf="dataGridSettings!.enableRadioButtons == true" class="radioButton" aria-label="selectReportType">
  <mat-radio-button value="1" (change)="radioChange($event)" [checked]="true">{{"periodic"|
    translate}}</mat-radio-button>
  <mat-radio-button value="2" (change)="radioChange($event)">{{"monthly"| translate}}</mat-radio-button>
  <mat-radio-button value="3" (change)="radioChange($event)">{{"annual"| translate}}</mat-radio-button>
</mat-radio-group>

<br>

<!--Search froms-->
<div class="bg-white w-full rounded-xl shadow-sm border-solid border-[0.025rem] p-7"
  *ngIf="dataGridSettings!.enableSearch">
  <form novalidate #dataGridSearchForm="ngForm" class="w-full">
    <div class="flex flex-col w-full gap-5">

      <div class="w-full flex flex-row justify-between">
        <p class="font-semibold text-[#475569]" *ngIf="dataGridSettings.searchTitle">{{dataGridSettings.searchTitle |
          translate}}</p>

        <div class="flex flex-row gap-5">
          <button class="transition-opacity duration-200 ease-in-out w-full h-full"
            [ngClass]="{'opacity-100 hover:cursor-pointer': searchDataActive, 'opacity-0 hover:cursor-auto pointer-events-none select-none': !searchDataActive}"
            (click)="cancelSearchData();" matTooltip='{{"Ресетирај филтри"}}'>
            <div class="flex flex-row  justify-between gap-3 align-middle items-center">
              <i class="lg:text-[1.35rem] text-[1.15rem] fa-solid fa-xmark text-[#f44336]"> </i>
              <p class="lg:text-[1.35rem] text-[1.15rem] text-[#f44336]"> Ресетирај филтри </p>
            </div>
          </button>

          <button mat-mini-fab color="primary" (click)="searchData();" matTooltip='{{"Search" | translate}}'>
            <i class="fa-solid fa-magnifying-glass" style="display: contents;"></i>
          </button>

        </div>
      </div>

      <div class="flex flex-col lg:flex-row w-full justify-between gap-3 lg:gap-[2rem]">

        <div class="flex flex-col gap-1" *ngIf="dataGridSettings.searchColumns!.indexOf('SearchParam') !== -1"
          [ngClass]="{'w-full': dataGridSettings.searchColumns!.indexOf('SearchParam') !== -1 && dataGridSettings.searchColumns!.indexOf('SelectionId') !== -1}">
          <mat-label>{{dataGridSettings.searchColumnName! | translate}}</mat-label>
          <mat-form-field appearance="outline" class="flex flex-row items-center"
            *ngIf="dataGridSettings.searchColumns!.indexOf('SearchParam') !== -1">
            <mat-icon matPrefix><i class="fa-regular fa-spa text-[2rem] pr-[1rem]"></i>
            </mat-icon>
            <input matInput type="text" placeholder='{{"Search" | translate}}' [(ngModel)]="searchModel.SearchParam"
              name="param" #param="ngModel" id="param" />
          </mat-form-field>
        </div>

        <div class="flex flex-col gap-1" *ngIf="dataGridSettings.searchColumns!.indexOf('SelectionId') !== -1"
          [ngClass]="{'w-full': dataGridSettings.searchColumns!.indexOf('SearchParam') !== -1 && dataGridSettings.searchColumns!.indexOf('SelectionId') !== -1}">
          <mat-label>{{ dataGridSettings!.selectionName! | translate }} </mat-label>
          <mat-form-field appearance="outline" class="flex flex-row items-center"
            *ngIf="dataGridSettings.searchColumns!.indexOf('SelectionId') !== -1">
            <mat-icon matPrefix *ngIf="dataGridSettings.dataGridName != 'Service'"><i
                class="fa-regular fa-user text-[2rem] pr-[1rem]"></i>
            </mat-icon>
            <mat-icon matPrefix *ngIf="dataGridSettings.dataGridName == 'Service'"><i
                class="fa-sharp fa-regular fa-box-taped mt-2 text-[2rem] pr-[1rem]"></i></mat-icon>
            <mat-select [(ngModel)]="searchModel.SelectionId" name="selectionId" #selectionId="ngModel"
              placeholder='{{"select" | translate}}' id="selectionId">
              <mat-option [value]="null">{{"Show all" | translate}}</mat-option>
              <mat-option *ngFor="let option of dataGridSettings.selectionList" [value]="option.id">
                {{option.name}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-col gap-1" *ngIf="dataGridSettings.searchColumns!.indexOf('SecondSelectionId') !== -1">
          <mat-form-field appearance="outline" class="flex flex-row items-center"
            *ngIf="dataGridSettings.searchColumns!.indexOf('SecondSelectionId') !== -1">
            <mat-icon matPrefix><i class="fa-regular fa-user mt-2 text-[2rem] pr-[1rem]"></i>
            </mat-icon>
            <mat-label>{{ dataGridSettings!.secondSelectionName! | translate }} </mat-label>
            <mat-select [(ngModel)]="searchModel.SecondSelectionId" name="secondSelectionId"
              #secondSelectionId="ngModel" id="secondSelectionId">
              <mat-option [value]="null">{{"Show all" | translate}}</mat-option>
              <mat-option *ngFor="let option of dataGridSettings.secondSelectionList" [value]="option.id">{{
                option.name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-col gap-1" *ngIf="dataGridSettings.searchColumns!.indexOf('DateFrom') !== -1">
          <mat-form-field appearance="outline" class="flex flex-row items-center"
            *ngIf="dataGridSettings.searchColumns!.indexOf('DateFrom') !== -1">
            <mat-icon matPrefix><i class="fa-regular fa-calendars mt-2 text-[2rem] pr-[1rem]"></i>
            </mat-icon>
            <input matInput [matDatepicker]="fromDate" placeholder='{{"Date of" | translate}}'
              [(ngModel)]="searchModel.FromDate" name="fromDate">
            <mat-datepicker-toggle matSuffix [for]="fromDate"></mat-datepicker-toggle>
            <mat-datepicker #fromDate></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="flex flex-col gap-1" *ngIf="dataGridSettings.searchColumns!.indexOf('DateTo') !== -1">
          <mat-form-field appearance="outline" class="flex flex-row items-center"
            *ngIf="dataGridSettings.searchColumns!.indexOf('DateTo') !== -1">
            <mat-icon matPrefix><i class="fa-regular fa-calendars mt-2 text-[2rem] pr-[1rem]"></i>
            </mat-icon>
            <input matInput [matDatepicker]="toDate" placeholder='{{"Date to" | translate}}'
              [(ngModel)]="searchModel.ToDate" name="toDate">
            <mat-datepicker-toggle matSuffix [for]="toDate"></mat-datepicker-toggle>
            <mat-datepicker #toDate></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

    </div>
  </form>
</div>

<br>

<!--      TABS-->
<div *ngIf="dataGridSettings.hasTabs" class="flex flex-row pb-4 justify-center mb-3 text-xs sm:text-base">
  <div *ngFor="let gridTab of dataGridSettings.tabs" class="w-full">
    <div class="hover:cursor-pointer text-center pb-3 px-5 uppercase text-2xl" (click)="changeTab(gridTab)"
      [ngClass]="{'text-[#475569] font-semibold border-2 border-t-transparent border-r-transparent border-l-transparent border-b-[#2C99B1]': gridTab.value==tab, 'text-stone-400 border border-transparent border-b-stone-400': gridTab.value!=tab}">
      {{gridTab.name}}
    </div>
  </div>

</div>

<div [ngStyle]="{'display' : dataGridSettingsValid ? 'inline-grid':'none'}" class="dGrid">
  <h3 *ngIf="dataGridSettings!.generateReportServiceName != null"
    style="display: flex; justify-content: flex-end; align-items: center;">{{"Generate report" | translate}}:
    <button mat-button (click)="generateReport()">
      <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
        <path fill="#20744a" fill-rule="evenodd"
          d="M28.781 4.405h-10.13V2.018L2 4.588v22.527l16.651 2.868v-3.538h10.13A1.162 1.162 0 0 0 30 25.349V5.5a1.162 1.162 0 0 0-1.219-1.095Zm.16 21.126H18.617l-.017-1.889h2.487v-2.2h-2.506l-.012-1.3h2.518v-2.2H18.55l-.012-1.3h2.549v-2.2H18.53v-1.3h2.557v-2.2H18.53v-1.3h2.557v-2.2H18.53v-2h10.411Z" />
        <path fill="#20744a"
          d="M22.487 7.439h4.323v2.2h-4.323zm0 3.501h4.323v2.2h-4.323zm0 3.501h4.323v2.2h-4.323zm0 3.501h4.323v2.2h-4.323zm0 3.501h4.323v2.2h-4.323z" />
        <path fill="#fff" fill-rule="evenodd"
          d="m6.347 10.673l2.146-.123l1.349 3.709l1.594-3.862l2.146-.123l-2.606 5.266l2.606 5.279l-2.269-.153l-1.532-4.024l-1.533 3.871l-2.085-.184l2.422-4.663l-2.238-4.993z" />
      </svg>
    </button>
  </h3>

  <div *ngIf="dataGridSettings!.enableSearch || dataGridSettings!.enableRefresh || dataGridSettings!.addUrl"
    class="box width_100_percent background_color_light_grey_1 padding_10 padding_bottom_5 searchLabels">

    <div class="float_right" style="margin-top: 6px;">
      <button class="text_color_blue float_right" mat-icon-button (click)="getData()" matTooltip="Освежи"
        *ngIf="dataGridSettings.enableRefresh">
        <i class="fa-solid fa-rotate" style="font-size: 3vh"></i>
      </button>
    </div>

  </div>

  <div class="box width_100_percent rounded-[0.75rem]" style="overflow:auto">
    <div class="box width_100_percent rounded-[0.75rem]" style="overflow:auto">
      <table mat-table [dataSource]="matDataSource" class="mat-elevation-z8 width_100_percent" matSort
        (matSortChange)="sortData($event)">
        <ng-container *ngFor="let item of dataGridSettings.columns; let last = last;" [matColumnDef]="item.DbName">

          <ng-container *ngIf="item.DbName.indexOf('CUSTOM') === -1">
            <th mat-header-cell *matHeaderCellDef mat-sort-header
              [ngStyle]="{ 'text-align': item.TextAlign ? item.TextAlign : 'left', 'width': item.Width ? item.Width : 'auto', 'font-weight': item.FontWeight ? item.FontWeight : 'normal'}">
              {{item.Name | translate}}
            </th>
          </ng-container>

          <ng-container *ngIf="item.DbName.indexOf('CUSTOM') !== -1">
            <th mat-header-cell *matHeaderCellDef
              [ngStyle]="{'text-align': item.TextAlign ? item.TextAlign : 'left','width': item.Width ? item.Width : 'auto','font-weight': item.FontWeight ? item.FontWeight : 'normal'}">
              {{item.Name | translate}}
            </th>
          </ng-container>

          <td mat-cell *matCellDef="let element"
            [ngStyle]="{'text-align': item.TextAlign ? item.TextAlign : 'left','width': item.Width ? item.Width : 'auto','font-weight': item.FontWeight ? item.FontWeight : ''}">
            <ng-container *ngIf="item.Type === 'string'">
              <ng-container *ngIf="item.IsDbNameNested">
                {{fixNestedDbName(element, item.DbName)}}
              </ng-container>
              <ng-container *ngIf="!item.IsDbNameNested">
                {{element[item.DbName] | translate}}
              </ng-container>
              <ng-container *ngIf="!item.IsDbNameNested">
              </ng-container>
            </ng-container>

            <ng-container *ngIf="item.Type === 'date'">
              <ng-container *ngIf="item.IsDbNameNested">
                {{fixNestedDbName(element, item.DbName) | date: (item.DateTimeFormat || 'dd.MM.yyyy HH:mm')
                }}
              </ng-container>
              <ng-container *ngIf="!item.IsDbNameNested">
                {{element[item.DbName] | date: (item.DateTimeFormat || 'dd.MM.yyyy HH:mm') }}
              </ng-container>
            </ng-container>

            <ng-container *ngIf="item.Type === 'datetime'">
              <ng-container *ngIf="item.IsDbNameNested">
                {{fixNestedDbName(element, item.DbName) | date: (item.DateTimeFormat || 'dd.MM.yyyy') }}
              </ng-container>
              <ng-container *ngIf="!item.IsDbNameNested">
                {{element[item.DbName] | date: (item.DateTimeFormat || 'dd.MM.yyyy') }}
              </ng-container>
            </ng-container>

            <ng-container *ngIf="item.Type === 'boolean'">
              <ng-container *ngIf="dataGridSettings.enableQuickEdit">
                <button mat-icon-button (click)="element[item.DbName] = !element[item.DbName]; edit(element);">
                  <span *ngIf="element[item.DbName]" class="items-center"><i class="fa-solid fa-circle"
                      style="font-size: 1.2vh;"></i> {{ "active" | translate }} </span>
                  <span *ngIf="!element[item.DbName]" class="items-center"><i class="fa-solid fa-circle"
                      style="font-size: 1.2vh;"></i> {{ "not active" | translate }} </span>
                </button>
              </ng-container>
              <ng-container *ngIf="!dataGridSettings.enableQuickEdit" class="w-full">
                <span *ngIf="element[item.DbName]"><i class="fa-solid fa-circle"
                    style="font-size: 1.2vh; color: #3FA155"></i> {{ "active" | translate }} </span>
                <span *ngIf="!element[item.DbName]"><i class="fa-solid fa-circle"
                    style="font-size: 1.2vh; color: #DA1414"></i> {{ "not active" | translate }} </span>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="item.Type === 'number'">
              <ng-container *ngIf="item.IsDbNameNested">
                {{fixNestedDbName(element, item.DbName)}}
              </ng-container>
              <ng-container *ngIf="!item.IsDbNameNested">
                {{element[item.DbName]}}
              </ng-container>
            </ng-container>

            <ng-container *ngIf="item.Type === 'image'">
              <img src="{{mediaUrl + element[item.DbName]}}" style="width:50px;" />
            </ng-container>

            <ng-container *ngIf="item.Type === 'view' && element['ID'] != null">
              <button mat-icon-button type="button" (click)="$event.stopPropagation();"
                [routerLink]="[ dataGridSettings.viewUrl, element['id'] ]">
                <mat-icon class="text_color_gray">remove_red_eye</mat-icon>
              </button>
            </ng-container>

            <ng-container *ngIf="item.Type === 'view' && element['ID'] != null">
              <button mat-icon-button type="button" (click)="$event.stopPropagation();"
                [routerLink]="[ dataGridSettings.viewUrl, element['id'] ]">
                <mat-icon class="text_color_gray">remove_red_eye</mat-icon>
              </button>
            </ng-container>

            <ng-container *ngIf="item.Type === 'edit'">
              <button mat-icon-button type="button" (click)="$event.stopPropagation(); editComponent(element['id'])">
                <i class="fa-solid fa-pencil"></i>
              </button>
            </ng-container>

            <ng-container *ngIf="item.Type === 'changePassword'">
              <button mat-icon-button type="button" (click)="$event.stopPropagation(); changePassword(element['id'])">
                <i class="fa-regular fa-key"></i>
              </button>
            </ng-container>

            <ng-container *ngIf="item.Type === 'delete'">
              <button class="text_color_red" mat-icon-button (click)="deleteComponent(element['id'])">
                <i class="fa-regular fa-trash-can"></i>
              </button>
            </ng-container>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onClick(row.ID)"></tr>
      </table>
    </div>

    <div style="display: flex; justify-content: center; align-items: center; padding: 1vh;" class="not-result"
      *ngIf="totalDataItems == 0">
      <svg width="64px" height="64px" viewBox="0 0 32 32" enable-background="new 0 0 32 32" id="_x3C_Layer_x3E_"
        version="1.1" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        fill="#9B9B9B">
        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <g id="search_x2C__magnifier_x2C__magnifying_x2C__emoji_x2C__No_results">
            <g id="XMLID_1857_">
              <g id="XMLID_1791_">
                <path d="M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z "
                  fill="#263238" id="XMLID_1797_"></path>
                <path d="M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z" fill="#263238"
                  id="XMLID_1794_"></path>
              </g>
            </g>
            <g id="XMLID_1764_">
              <g id="XMLID_4103_">
                <line fill="none" id="XMLID_4109_" stroke="#455A64" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10" x1="23.43" x2="21.214" y1="23.401" y2="21.186"></line>
                <path
                  d=" M29.914,27.086l-3.5-3.5c-0.756-0.756-2.072-0.756-2.828,0C23.208,23.964,23,24.466,23,25s0.208,1.036,0.586,1.414l3.5,3.5 c0.378,0.378,0.88,0.586,1.414,0.586s1.036-0.208,1.414-0.586S30.5,29.034,30.5,28.5S30.292,27.464,29.914,27.086z"
                  fill="none" id="XMLID_4108_" stroke="#455A64" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10"></path>
                <circle cx="13" cy="13" fill="none" id="XMLID_4107_" r="11.5" stroke="#455A64" stroke-linecap="round"
                  stroke-linejoin="round" stroke-miterlimit="10"></circle>
                <path d=" M12,15.521c0-0.55,0.45-1,1-1s1,0.45,1,1" fill="none" id="XMLID_4106_" stroke="#455A64"
                  stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                </path>
                <path d=" M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z"
                  fill="none" id="XMLID_4105_" stroke="#455A64" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10"></path>
                <path d=" M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z" fill="none"
                  id="XMLID_4104_" stroke="#455A64" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10"></path>
              </g>
              <g id="XMLID_4096_">
                <line fill="none" id="XMLID_4102_" stroke="#263238" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10" x1="23.43" x2="21.214" y1="23.401" y2="21.186"></line>
                <path
                  d=" M29.914,27.086l-3.5-3.5c-0.756-0.756-2.072-0.756-2.828,0C23.208,23.964,23,24.466,23,25s0.208,1.036,0.586,1.414l3.5,3.5 c0.378,0.378,0.88,0.586,1.414,0.586s1.036-0.208,1.414-0.586S30.5,29.034,30.5,28.5S30.292,27.464,29.914,27.086z"
                  fill="none" id="XMLID_4101_" stroke="#263238" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10"></path>
                <circle cx="13" cy="13" fill="none" id="XMLID_4100_" r="11.5" stroke="#263238" stroke-linecap="round"
                  stroke-linejoin="round" stroke-miterlimit="10"></circle>
                <path d=" M12,15.521c0-0.55,0.45-1,1-1s1,0.45,1,1" fill="none" id="XMLID_4099_" stroke="#263238"
                  stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10">
                </path>
                <path d=" M17.5,13c0.27,0,0.5,0.23,0.5,0.5S17.77,14,17.5,14S17,13.77,17,13.5S17.23,13,17.5,13z"
                  fill="none" id="XMLID_4098_" stroke="#263238" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10"></path>
                <path d=" M8.5,13C8.77,13,9,13.23,9,13.5S8.77,14,8.5,14S8,13.77,8,13.5S8.23,13,8.5,13z" fill="none"
                  id="XMLID_4097_" stroke="#263238" stroke-linecap="round" stroke-linejoin="round"
                  stroke-miterlimit="10"></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
      <h1 style="margin-top:7px;color: #9B9B9B;font-size:21px;font-weight: 500; padding-left: 2vh;">{{"No results found"
        | translate}}</h1>
    </div>

    <div class="box width_100_percent">
      <mat-paginator [pageSizeOptions]="pageSizes" [length]="totalDataItems" showFirstLastButtons
        class="background_color_light_grey1" (page)="initPager($event)" #paginator>
      </mat-paginator>
    </div>

  </div>

</div>

<!-- Popups User -->
<app-generic-modal *ngIf="userAddPopupState" [bannerText]="('users-add' | translate )" [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopup()">

<app-user-popup (close)="closePopup()"></app-user-popup>

</app-generic-modal>

<app-generic-modal *ngIf="editUserPopupState" [bannerText]="('users-edit' | translate )" [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopup()">

  <app-user-popup (close)="closePopup()" [userId]="userId"></app-user-popup>

</app-generic-modal>

<!-- Service User -->
<app-generic-modal *ngIf="addServicePopupState" [bannerText]="'Add Service' | translate " [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopup()">

  <app-service-popup (close)="closePopup()"></app-service-popup>

</app-generic-modal>

<app-generic-modal *ngIf="editServicePopupState" [bannerText]="'Edit Service' | translate " [handle_extreme_overflow]="false"
  [handle_mobile]="true" (handleCloseEmitter)="closePopup()">
  <app-service-popup (close)="closePopup()" [serviceId]="serviceId"></app-service-popup>
</app-generic-modal>

<app-generic-modal *ngIf="changePasswordPopupState" [handle_mobile]="false" (handleCloseEmitter)="closePopup()"
  [bannerText]="'changePassword' | translate ">
  <div class="sm:w-[30rem] center-items grid text-center">

    <form [formGroup]="changePasswordForm!">

      <div class="flex flex-col m-3">
        <mat-label>{{"newPassword" | translate}}</mat-label>
        <mat-form-field appearance="outline" class="flex flex-row items-center ">
          <input type="password" matInput [(ngModel)]="changePasswordForUserRequestData.newPassword" formControlName="newPassword"  required minlength="6"/>
            <mat-error *ngIf="changePasswordForm!.get('newPassword')?.errors?.['required']">
            <span>{{ 'Required Field' | translate }}</span>
          </mat-error>
          <mat-error *ngIf="changePasswordForm!.get('newPassword')?.errors?.['minlength']">
            <span>{{ 'Required minimum 6 characters' | translate }}</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-col m-3 ">
        <mat-label>{{"confirmPassword" | translate}}</mat-label>
        <mat-form-field appearance="outline" class="flex flex-row items-center ">

          <input type="password" matInput [(ngModel)]="confirmPassword" formControlName="confirmPassword" minlength="6" required />
          <mat-error *ngIf="changePasswordForm!.get('confirmPassword')?.errors?.['required']">
            <span>{{ 'Required Field' | translate }}</span>
          </mat-error>
          <mat-error *ngIf="changePasswordForm!.get('confirmPassword')?.errors?.['minlength']">
            <span>{{ 'Required minimum 6 characters' | translate }}</span>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="flex flex-row gap-10 text-[1rem] sm:text-[1.35rem] mt-5">
        <button (click)="closePopup();" type="button"
          class="w-1/2 px-5 py-[.5rem] uppercase rounded-[.25rem] bg-[#dadada] text-[#696767] hover:bg-[#c4c4c4] shadow-md active:scale-[0.985] active:shadow-sm">
          {{"back" | translate}}
        </button>

        <button type="submit"
          (click)="savePassword();"
          class=" bg-[#b98d78] hover:bg-[#a57d6a]w-1/2 uppercase px-5 w-1/2 py-[.5rem] rounded-[.25rem] text-white shadow-md active:scale-[0.985] active:shadow-sm">
          {{ 'Save' | translate }}
        </button>
      </div>
    </form>
  </div>
</app-generic-modal>
